import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';
import type { ViewPagePdfExportProps } from './ViewPagePdfExportPage.tsx';

export const ViewPagePdfExportLoader: LoadableType<ViewPagePdfExportProps> = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-view-page-pdf-export" */ './ViewPagePdfExportPage.tsx'
			)
		).ViewPagePdfExportPage,
});
